import React, {useState, useEffect, useRef} from 'react';
import {observer} from "mobx-react";
import styles from "../Widgets/WidgetIndicateur/WidgetIndicateur.module.scss";

const CreateIndicateurApercu = observer(({
                                             listeSeuils,
                                             WidgetMisEnForme,
                                             WidgetForme,
                                             WidgetName,
                                             WidgetUnite,
                                             WidgetValeur,
                                             ValeurExemple
                                         }) => {
    const [backgroundColor, setBackgroundColor] = useState('#bdc3c7');
    const [icon, setIcon] = useState('');

    useEffect(() => {
        if (listeSeuils) {
            setBackgroundColor("#fff");
            listeSeuils.forEach(SEUIL => {
                const value = parseFloat(ValeurExemple);
                const seuilValue = parseFloat(SEUIL.seu_valeur.toString().replace(",", "."));
                if ((SEUIL.seu_sens === "superieur" && value > seuilValue) ||
                    (SEUIL.seu_sens === "inferieur" && value < seuilValue) ||
                    (SEUIL.seu_sens === "=" && value === seuilValue) ||
                    (SEUIL.seu_sens === "inferieur_egal" && value <= seuilValue) ||
                    (SEUIL.seu_sens === "superieur_egal" && value >= seuilValue)) {
                    if (WidgetMisEnForme === 'geometric' || !WidgetMisEnForme) {
                        setBackgroundColor(SEUIL.seu_couleur);
                    } else {
                        setIcon(SEUIL.seu_couleur);
                    }
                }
            });
        }
    }, [ValeurExemple, listeSeuils]);

    return (
        <div className={`carte_widget ${styles.container}`} style={{height: "70%"}}>
            <div className={styles.nomWidget}>{WidgetName}</div>

            <div className={styles.formeEtValeur}>
                <div
                    className={`${WidgetForme === 'rond' ? styles.rond : WidgetForme === 'carre' ? styles.carre : styles.triangle}`}
                    style={WidgetForme !== 'triangle' ? {
                        backgroundColor,
                        overflow: "hidden",
                        outline: "none"
                    } : {overflow: "hidden", outline: "none"}}
                >
                    {WidgetMisEnForme === 'geometric' || !WidgetMisEnForme ? (
                        WidgetValeur === 1 ? (
                            <span className={`${styles.valeur} relative ${WidgetForme === 'triangle' ? 'h-full' : ''}`}>
                                {
                                    WidgetForme === 'triangle' && (
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                             className={"h-full w-full absolute"} fill={backgroundColor}
                                             viewBox="0 0 16 16">
                                            <path fillRule="evenodd"
                                                  d="M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767z"/>
                                        </svg>
                                    )}
                                <span
                                    className={`${styles.valeur} ${WidgetForme === 'triangle' ? styles.triangle_span : ''}`}>
                                    {ValeurExemple || "---"}
                                    <span className={styles.unite}>{WidgetUnite}</span>
                                </span>
                            </span>
                        ) : ""
                    ) : (
                        <div>
                            <span className={styles.valeur}>
                                <div
                                    className={`flex relative justify-center items-center ${WidgetValeur === 4 ? 'flex-row-reverse' : WidgetValeur === 5 ? 'flex-row' : ''} ${WidgetValeur === 2 ? 'flex-col-reverse justify-center items-center' : WidgetValeur === 3 ? 'flex-col justify-center items-center' : ''}`}>
                                    {icon}
                                    {WidgetValeur !== 0 && (
                                        <span>{ValeurExemple || "---"}{WidgetUnite}</span>
                                    )}
                                </div>
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});

export default CreateIndicateurApercu;
